@import '~style-sheet-helpers/core.less';

.scan-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .body {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
  }
}
